import axios from "axios";
const Api = {};
const method = ["get", "post", "put", "delete"];

method.forEach((item) => {
  /**
   *
   * @param {string} url  接口地址
   * @param {object} data 请求数据
   * @param {object} option 请求配置
   *
   * @return {Promise}
   */
  Api[item] = (url = "", data, options = {}) =>
    new Promise((resolve, reject) => {
      const headers = {
        //   "X-CSRF-TOKEN": _global && _global.csrf_token,
      };
      let _options = {
        headers,
      };
      if (options && options.headers) {
        _options.headers = Object.assign({}, headers, options.headers);
      }
      if (options && options.responseType) {
        _options.responseType = options.responseType;
      }
      axios(
        Object.assign(
          {
            url: `${url}`,
            method: item,
            params: item === "get" ? data : null,
            data,
          },
          _options
        )
      )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            console.log("404 not found");
            return;
          }
          if (error.response && error.response.data) {
            console.log("error.response");
            console.log(error.response);
            reject(error.response);
          }
        });
    });
});

const _global = {
  wxAppInfo: {
    app_id: "wx9f2a29a362b7501f",
  },
};

export { Api, _global };
